import { render, staticRenderFns } from "./QuestionMoment.vue?vue&type=template&id=57f77ed0&"
import script from "./QuestionMoment.vue?vue&type=script&lang=js&"
export * from "./QuestionMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports